import { render, staticRenderFns } from "./DisbursementsProcessed.vue?vue&type=template&id=f012f47c"
import script from "./DisbursementsProcessed.vue?vue&type=script&lang=js"
export * from "./DisbursementsProcessed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports